<template>
  <v-card :color="cardColor" v-bind="$attrs" class="v-card--material pa-3 rounded-lg mt-7" elevation="2">
    <div class="d-flex grow flex-wrap">
      <v-avatar v-if="avatar" size="128" class="mx-auto v-card--material__avatar elevation-2" color="grey">
        <v-img :src="avatar" />
      </v-avatar>

      <v-sheet
        v-else
        :class="{
          'pa-5': !$slots.image
        }"
        :color="color"
        :max-height="icon ? 90 : undefined"
        :width="inline || icon ? 'auto' : '100%'"
        class="text-start v-card--material__heading rounded-lg"
        elevation="2"
        dark
      >
        <slot v-if="$slots.heading" name="heading" />

        <slot v-else-if="$slots.image" name="image" />

        <div v-else-if="title && !icon" class="display-1 font-weight-light" v-text="title" />

        <v-icon v-else-if="icon" size="36" v-text="icon" />

        <div v-if="text" class="headline font-weight-thin" v-text="text" />
      </v-sheet>
      <div v-if="$slots['after-heading']" class="ml-6">
        <slot name="after-heading" />
      </div>

      <v-col v-if="hoverReveal" cols="12" class="text-center py-0 mt-n12">
        <slot name="reveal-actions" />
      </v-col>

      <div v-else-if="icon && title" class="ml-4">
        <div class="font-weight-regular headline text-decoration-underline text-capitalize" v-text="title" />
      </div>
      <div v-else-if="icon && smalltitle" class="ml-auto text-right">
        <div class="font-weight-regular">
          <div class="font-weight-regular" v-text="smalltitle" />
          <h3 class="display-2 font-weight-light text--primary">
            <small>{{ vsmallvalue }}</small>
          </h3>
        </div>
      </div>
    </div>
    <slot />

    <template v-if="$slots.actions">
      <v-divider class="mt-2" />

      <v-card-actions class="pb-0">
        <slot name="actions" />
      </v-card-actions>
    </template>
  </v-card>
</template>

<script>
export default {
  name: 'MaterialCard',
  // data: function () {
  //   return {
  //     title: null
  //   }
  // },
  props: {
    avatar: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'green'
    },
    cardColor: {
      type: String,
      default: ''
    },
    hoverReveal: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: undefined
    },
    image: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      Object,
      default: ''
    },
    smalltitle: {
      type: String,
      Object,
      default: ''
    },
    vsmallvalue: {
      type: Number,
      String,
      Object,
      default: null
    }
  },

  computed: {}
}
</script>

<style lang="sass">
.v-card--material
  &__avatar
    position: relative
    top: -64px
    margin-bottom: -32px

  &__heading
    position: relative
    top: -40px
    transition: .3s ease
    z-index: 1

  &.v-card--material--hover-reveal:hover
    .v-card--material__heading
      transform: translateY(-40px)
</style>
